"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ClientRequest_1 = __importDefault(require("../ClientRequest"));
const AuthApi = {
    checkEmailAvailable: async (email) => {
        const res = await ClientRequest_1.default.patch("users/user-login-with-fujisan", {
            email,
        });
        return res.data;
    },
    loginWithFujisan: async (email, password) => {
        const res = await ClientRequest_1.default.post("login-with-fujisan", {
            email,
            password,
        });
        return res.data;
    },
    createAnonymousUser: async () => {
        const res = await ClientRequest_1.default.post("users/anonymous");
        return res;
    },
    signUpWithFujisan: async (email, password) => {
        const res = await ClientRequest_1.default.post("users/signup-with-fujisan-authn", {
            email,
            password,
        });
        return res.data;
    },
};
exports.default = AuthApi;
